import { createStyles as p } from "@mantine/core";
var t = Object.defineProperty, f = Object.defineProperties, e = Object.getOwnPropertyDescriptors, s = Object.getOwnPropertySymbols, k = Object.prototype.hasOwnProperty, S = Object.prototype.propertyIsEnumerable, c = (o, r, i) => r in o ? t(o, r, { enumerable: !0, configurable: !0, writable: !0, value: i }) : o[r] = i, a = (o, r) => {
  for (var i in r || (r = {}))
    k.call(r, i) && c(o, i, r[i]);
  if (s)
    for (var i of s(r))
      S.call(r, i) && c(o, i, r[i]);
  return o;
}, l = (o, r) => f(o, e(r)), u = p((o, { saveLabel: r, removeLabel: i, editLabel: d, radius: n, readOnly: g }) => ({
  toolbar: {
    display: g ? "none" : void 0
  },
  root: l(a({}, o.fn.fontStyles()), {
    fontSize: o.fontSizes.sm,
    border: `1px solid ${o.colorScheme === "dark" ? o.colors.dark[5] : o.colors.gray[4]}`,
    backgroundColor: o.colorScheme === "dark" ? o.colors.dark[6] : o.white,
    borderRadius: o.fn.radius(n),
    position: "relative",
    color: o.colorScheme === "dark" ? o.colors.dark[0] : o.black,
    "& .ql-toolbar": {
      borderTopRightRadius: o.fn.radius(n),
      borderTopLeftRadius: o.fn.radius(n)
    },
    "& .ql-container": {
      position: "relative",
      boxSizing: "border-box",
      height: "100%",
      margin: 0,
      lineHeight: o.lineHeight
    },
    "& .ql-editor": {
      whiteSpace: "pre-wrap",
      outline: "none",
      padding: `${o.spacing.sm}px ${o.spacing.md}px`
    },
    "& .ql-container.ql-disabled .ql-tooltip": {
      display: "none"
    },
    "& .ql-tooltip": {
      position: "absolute",
      zIndex: 1,
      backgroundColor: o.colorScheme === "dark" ? o.colors.dark[5] : o.white,
      padding: `${o.spacing.xs}px ${o.spacing.md}px`,
      border: `1px solid ${o.colorScheme === "dark" ? o.colors.dark[5] : o.colors.gray[2]}`,
      boxShadow: o.shadows.sm,
      borderRadius: o.radius.sm,
      display: "flex",
      alignItems: "center"
    },
    "& .ql-action::before": {
      content: `"${d}"`,
      cursor: "pointer",
      display: "block",
      whiteSpace: "nowrap",
      height: 32,
      lineHeight: "32px",
      backgroundColor: o.fn.variant({ variant: "filled" }).background,
      color: o.white,
      borderRadius: o.fn.radius(o.defaultRadius),
      fontWeight: 500,
      padding: `0 ${o.spacing.md}px`,
      marginRight: o.spacing.sm,
      fontSize: o.fontSizes.sm
    },
    "& .ql-remove::before": {
      content: `"${i}"`,
      cursor: "pointer",
      color: o.colors.red[o.colorScheme === "dark" ? 5 : 7],
      fontSize: o.fontSizes.sm,
      display: "block",
      height: 32,
      lineHeight: "32px"
    },
    "& .ql-hidden": {
      display: "none"
    },
    "& .ql-preview": {
      display: "inline-block",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden",
      maxWidth: 180,
      marginRight: o.spacing.md
    },
    "& .ql-editing .ql-preview": {
      display: "none"
    },
    "& .ql-editing .ql-remove": {
      display: "none"
    },
    "& .ql-editing .ql-action::before": {
      content: `"${r}"`,
      marginRight: 0
    },
    "& .ql-tooltip.ql-editing input": {
      display: "block"
    },
    "& .ql-tooltip input": {
      display: "none",
      WebkitTapHighlightColor: "transparent",
      height: 34,
      appearance: "none",
      resize: "none",
      boxSizing: "border-box",
      fontSize: o.fontSizes.sm,
      width: "100%",
      color: o.colorScheme === "dark" ? o.colors.dark[0] : o.black,
      textAlign: "left",
      paddingLeft: o.spacing.sm,
      paddingRight: o.spacing.sm,
      borderRadius: o.fn.radius(o.defaultRadius),
      marginRight: o.spacing.md,
      border: `1px solid ${o.colorScheme === "dark" ? o.colors.dark[4] : o.colors.gray[4]}`,
      backgroundColor: o.colorScheme === "dark" ? o.colors.dark[6] : o.white,
      "&::placeholder": a({
        opacity: 1
      }, o.fn.placeholderStyles()),
      "&:focus": {
        outline: "none",
        borderColor: o.colors[o.primaryColor][o.colorScheme === "dark" ? 8 : 5]
      }
    },
    "& .ql-clipboard": {
      left: "-100000px",
      height: "1px",
      overflowY: "hidden",
      position: "fixed",
      top: "50%"
    },
    "& .ql-align-center": {
      textAlign: "center"
    },
    "& .ql-align-right": {
      textAlign: "right"
    },
    "& .ql-mention-list-container": {
      border: `1px solid ${o.colorScheme === "dark" ? o.colors.dark[5] : o.colors.gray[4]}`,
      backgroundColor: o.colorScheme === "dark" ? o.colors.dark[6] : o.white,
      borderRadius: o.radius.sm,
      overflow: "hidden",
      "& .ql-mention-list": {
        color: o.colorScheme === "dark" ? o.colors.dark[0] : o.colors.gray[7],
        paddingLeft: 0,
        marginTop: 0,
        margin: 0,
        listStyleType: "none",
        "& .ql-mention-list-item": {
          padding: o.spacing.xs,
          textDecoration: "none",
          cursor: "pointer"
        },
        "& .selected": {
          backgroundColor: o.colorScheme === "dark" ? o.colors.dark[4] : o.colors.gray[0],
          color: o.colorScheme === "dark" ? o.white : o.black,
          textDecoration: "none"
        }
      }
    },
    "& .mention": {
      display: "inline-block",
      color: o.colorScheme === "dark" ? o.colors.dark[0] : o.black,
      backgroundColor: o.colorScheme === "dark" ? o.colors.dark[4] : o.colors[o.primaryColor][0],
      padding: "3px 5px",
      marginRight: 2,
      borderRadius: o.fn.radius(o.defaultRadius),
      userSelect: "all",
      pointerEvents: "none"
    },
    "& iframe.ql-video": {
      width: "100%",
      height: 400,
      "@media (max-width: 755px)": {
        height: 220
      }
    },
    "& a": {
      color: o.colors[o.primaryColor][o.colorScheme === "dark" ? 4 : 7],
      textDecoration: "none"
    },
    "& h1, & h2, & h3, & h4, & h5, & h6": {
      fontFamily: o.headings.fontFamily,
      fontWeight: o.headings.fontWeight,
      marginTop: 0
    },
    "& ol, & ul": {
      marginTop: o.spacing.sm,
      paddingLeft: `calc(${o.spacing.md}px * 2)`,
      listStylePosition: "outside"
    },
    "& h1": {
      fontSize: o.headings.sizes.h1.fontSize,
      marginBottom: `calc(${o.spacing.sm}px * ${o.headings.sizes.h1.lineHeight})`
    },
    "& h2": {
      fontSize: o.headings.sizes.h2.fontSize,
      marginBottom: `calc(${o.spacing.sm}px * ${o.headings.sizes.h2.lineHeight})`
    },
    "& h3": {
      fontSize: o.headings.sizes.h3.fontSize,
      marginBottom: `calc(${o.spacing.sm}px * ${o.headings.sizes.h3.lineHeight})`
    },
    "& h4": {
      fontSize: o.headings.sizes.h4.fontSize,
      marginBottom: `calc(${o.spacing.sm}px * ${o.headings.sizes.h4.lineHeight})`
    },
    "& h5": {
      fontSize: o.headings.sizes.h5.fontSize,
      marginBottom: `calc(${o.spacing.sm}px * ${o.headings.sizes.h5.lineHeight})`
    },
    "& h6": {
      fontSize: o.headings.sizes.h6.fontSize,
      marginBottom: `calc(${o.spacing.sm}px * ${o.headings.sizes.h6.lineHeight})`
    },
    "& p": {
      marginTop: 0,
      marginBottom: o.spacing.sm
    },
    "& pre": l(a({}, o.fn.fontStyles()), {
      lineHeight: o.lineHeight,
      borderRadius: o.radius.sm,
      color: o.colorScheme === "dark" ? o.colors.dark[0] : o.black,
      backgroundColor: o.fn.rgba(o.fn.themeColor("gray", o.colorScheme === "dark" ? 8 : 0), o.colorScheme === "dark" ? 0.35 : 1),
      fontFamily: o.fontFamilyMonospace,
      fontSize: o.fontSizes.xs,
      padding: o.spacing.xs,
      margin: 0,
      overflowX: "auto"
    }),
    "& code": l(a({}, o.fn.fontStyles()), {
      lineHeight: o.lineHeight,
      borderRadius: o.radius.sm,
      color: o.colorScheme === "dark" ? o.colors.dark[0] : o.black,
      backgroundColor: o.fn.rgba(o.fn.themeColor("gray", o.colorScheme === "dark" ? 8 : 0), o.colorScheme === "dark" ? 0.35 : 1),
      fontFamily: o.fontFamilyMonospace,
      fontSize: o.fontSizes.xs,
      padding: `2px calc(${o.spacing.xs}px / 2)`
    }),
    "& blockquote": {
      marginTop: 0,
      marginLeft: 0,
      marginBottom: o.spacing.sm,
      paddingLeft: o.spacing.md,
      color: o.colorScheme === "dark" ? o.colors.dark[2] : o.colors.gray[7],
      borderLeft: `4px solid ${o.colorScheme === "dark" ? o.colors.dark[4] : o.colors.gray[4]}`
    },
    "& img": {
      display: "block",
      position: "relative",
      maxWidth: "100%",
      marginBottom: o.spacing.sm
    },
    "& .ql-image-uploading img": {
      filter: "blur(10px)"
    },
    "& .ql-blank": {
      "&::before": {
        content: "attr(data-placeholder)",
        position: "absolute",
        left: o.spacing.md,
        right: o.spacing.md,
        color: o.colorScheme === "dark" ? o.colors.dark[3] : o.colors.gray[5]
      }
    }
  })
}));
export {
  u as default
};
